import { CodeIcon } from "@heroicons/react/solid";
import React, { useState } from "react";

const headers = {
  Accept: "application/json",
  Authorization: `Bearer ${process.env.REACT_APP_RING_API}`,
};

const Ring = () => {
  const [counter, setCounter] = useState(0);
  const [quote, setQuote] = useState("");
  const [character, setCharacter] = useState("");

  const fetchData = async () => {
    if (counter === 10) {
      return;
    }
    try {
      const rawQuotes = await fetch("https://the-one-api.dev/v2/quote", { headers });
      const quotes = await rawQuotes.json();

      if (!quotes.docs) {
        throw new Error("No quotes found");
      }

      const randomQuote = quotes.docs[Math.floor(Math.random() * quotes.docs.length)];
      setQuote(randomQuote.dialog);

      const rawCharacters = await fetch(
        `https://the-one-api.dev/v2/character?_id=${randomQuote.character}`,
        {
          headers,
        }
      );
      const characters = await rawCharacters.json();

      if (!characters.docs) {
        throw new Error("No characters found");
      }

      const randomCharacter = characters.docs[0];
      setCharacter(randomCharacter.name);
      setCounter(counter + 1);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="container px-5 py-10 mx-auto text-center lg:px-40">
      <div className="flex flex-col w-full mb-20">
        <CodeIcon className="mx-auto inline-block w-10 mb-4" />
        <h1 className="sm:text-4xl text-3xl font-medium title-font mb-4 text-white">
          The One and Only Ring
        </h1>
        <p className="lg:w-2/3 mx-auto leading-relaxed text-base p-4">
          As a versatile customer success manager and implementation specialist,
          I leveraged my technical skills in RESTful API design to deliver a
          dynamic Lord of The Rings quote generator utilizing the fetch method
          in my React Netlify application. By integrating with{" "}
          <a href="https://the-one-api.dev/" class="text-pink-600 font-bold">
            The One and Only Ring API
          </a>
          , I was able to make HTTP requests to fetch random quotes and
          characters, which were then displayed on the webpage. I ensured secure
          authentication methods by storing the API key in the .env file, thus
          creating a reliable and secure application. This accomplishment
          showcases my ability to integrate diverse APIs, helping businesses
          achieve optimal growth and success. Contact me to learn more about my
          skills and  <a href="#experience">experience!</a>
        </p>

        <div className="flex flex-col mb-10 text-left border-solid border-2 border-sky-500 p-20 mx-auto">
          <p className="text-base leading-relaxed">Character: {character}</p>
          <p className="text-base leading-relaxed">Quote: {quote}</p>
        </div>
        <div className="p-0 mt-4">
          <button
            onClick={fetchData}
            className="inline-flex text-white bg-pink-500 border-0 py-2 px-6 focus:outline-none hover:bg-pink-600 rounded text-lg"
          >
            Fetch Data
            </button>
        </div>
      </div>
    </div>
  );
};

export default Ring;




// WEBPACK FOOTER //
// ./src/components/Ring.js